import { Link } from "@/i18n/navigation";
import { useAuth } from "@/shared/providers/AuthProvider";
import { SubscriptionTier } from "@/entities/billing/lib/billing.constants";

const PricingCardPro = () => {
  const { user } = useAuth();

  return (
    <div
      className={
        "relative h-[612px] w-full rounded-lg border border-primary px-[24px] pt-[28px] sm:w-[320px] sm:min-w-[320px]"
      }
    >
      <div
        className={
          "absolute right-[20px] top-[-15px] flex h-[30px] w-fit items-center justify-center rounded-md border border-[#FF1B1B] bg-white px-[8px] py-[4px]"
        }
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1058_1913)">
            <rect width="15" height="15" rx="7.5" fill="#FF1B1B" />
            <path
              d="M14.375 7.49375L12.85 5.75L13.0625 3.44375L10.8063 2.93125L9.625 0.9375L7.5 1.85L5.375 0.9375L4.19375 2.93125L1.9375 3.4375L2.15 5.75L0.625 7.49375L2.15 9.2375L1.9375 11.55L4.19375 12.0625L5.375 14.0625L7.5 13.1438L9.625 14.0562L10.8063 12.0625L13.0625 11.55L12.85 9.24375L14.375 7.49375ZM11.9062 8.41875L11.5562 8.825L11.6062 9.35625L11.7188 10.575L10.5312 10.8438L10.0063 10.9625L9.73125 11.425L9.1125 12.475L8 11.9938L7.5 11.7812L7.00625 11.9938L5.89375 12.475L5.275 11.4313L5 10.9688L4.475 10.85L3.2875 10.5813L3.4 9.35625L3.45 8.825L3.1 8.41875L2.29375 7.5L3.1 6.575L3.45 6.16875L3.39375 5.63125L3.28125 4.41875L4.46875 4.15L4.99375 4.03125L5.26875 3.56875L5.8875 2.51875L7 3L7.5 3.2125L7.99375 3L9.10625 2.51875L9.725 3.56875L10 4.03125L10.525 4.15L11.7125 4.41875L11.6 5.6375L11.55 6.16875L11.9 6.575L12.7063 7.49375L11.9062 8.41875Z"
              fill="white"
            />
            <path
              d="M6.30469 8.59297L4.85469 7.13672L3.92969 8.06797L6.30469 10.4492L10.8922 5.84922L9.96719 4.91797L6.30469 8.59297Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1058_1913">
              <rect width="15" height="15" rx="7.5" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span className={"ml-[4px] text-caption2 font-[600] text-[#FF1B1B]"}>
          MOST POPULAR
        </span>
      </div>
      <div>
        <div
          className={
            "flex h-[36px] w-[120px] items-center justify-center rounded-md bg-primary text-title2 text-white"
          }
        >
          Pro
        </div>
        <div className={"mt-[6px] h-[56px] text-[10px] text-gray-400"}>
          매출 성장을 앞두고{" "}
          <span className={"font-[600] text-primary"}>
            본격적인 AI 에이전트 활용
          </span>
          이 필요한 회사에 추천하는 요금제{" "}
        </div>
      </div>
      <div className={""}>
        <div className={"flex items-end justify-start"}>
          <div className={"text-[28px] font-[800] text-primary sm:text-[30px]"}>
            ₩ 90,000원
          </div>
          <div
            className={
              "mb-[4px] ml-[8px] text-label2 font-[600] text-gray-400 sm:text-body2"
            }
          >
            / 월
          </div>
          <div
            className={
              "mb-[4px] ml-[4px] text-caption2 font-[600] text-gray-200"
            }
          >
            {" "}
            (VAT별도)
          </div>
        </div>
      </div>
      <div className={"mt-[32px]"}>
        <Link
          href={
            user?._id
              ? `/dashboard/billing/subscription?tier=${SubscriptionTier.Pro}`
              : "/auth/sign-in"
          }
          className={
            "flex h-[40px] w-full items-center justify-center rounded-md border border-primary bg-primary text-title2 text-white"
          }
        >
          시작하기
        </Link>
      </div>
      <div className={"mt-[52px] w-full"}>
        <div
          className={
            "w-full rounded-xs border-[3px] border-dashed border-[#F84949] bg-[#FFF9F9] px-[12px] py-[7px] text-label2 font-[800] text-[#FF1B1B]"
          }
        >
          Starter 요금제의 모든 기능 +
        </div>
        <div className={"mt-[18px] w-full"}>
          <div
            className={
              "flex w-full items-center justify-start gap-[22px] text-primary"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#009EFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600]"}>데이터 튜닝</span>
          </div>
          <div
            className={
              "mt-[2px] flex w-full items-start justify-start gap-[6px] pl-[22px]"
            }
          >
            <svg
              className={"mt-[1px]"}
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1058_1953)">
                <path
                  d="M10.4991 4.37539L9.67661 3.49414L5.97828 7.45664L6.80078 8.33789L10.4991 4.37539ZM12.9724 3.49414L6.80078 10.1066L4.36245 7.50039L3.53995 8.38164L6.80078 11.8754L13.8008 4.37539L12.9724 3.49414ZM0.238281 8.38164L3.49911 11.8754L4.32161 10.9941L1.06661 7.50039L0.238281 8.38164Z"
                  fill="#213F98"
                />
              </g>
              <defs>
                <clipPath id="clip0_1058_1953">
                  <rect width="14" height="15" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className={"text-caption2 font-[600] text-primary-dark"}>
              <span className={"text-label2"}>
                더 정확한 맞춤형 AI 에이전트 제작 기능
              </span>
              <ul className={"pl-[0px]"}>
                <li className={"list-disc font-[500] text-gray-500"}>
                  AI의 답변 정확도 상향 위한 데이터 작업{" "}
                </li>
                <li className={"list-disc font-[500] text-gray-500"}>
                  키워드 입력을 통해 더 많은 질문에 답변
                </li>

                <li className={"list-disc font-[500] text-gray-500"}>
                  응답 가이드를 통해 AI 답변을 맞춤형 제작
                </li>
                <li className={"list-disc font-[500] text-gray-500"}>
                  업로드 문서 개인정보 탐지 및 검토 후 인덱싱
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={"mt-[24px] w-full"}>
          <div
            className={
              "flex w-full items-center justify-start gap-[22px] text-primary"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#009EFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600]"}>상담 매니저 기능</span>
          </div>
          <div
            className={
              "mt-[2px] flex w-full items-start justify-start gap-[6px] pl-[22px]"
            }
          >
            <svg
              className={"mt-[1px]"}
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1058_1953)">
                <path
                  d="M10.4991 4.37539L9.67661 3.49414L5.97828 7.45664L6.80078 8.33789L10.4991 4.37539ZM12.9724 3.49414L6.80078 10.1066L4.36245 7.50039L3.53995 8.38164L6.80078 11.8754L13.8008 4.37539L12.9724 3.49414ZM0.238281 8.38164L3.49911 11.8754L4.32161 10.9941L1.06661 7.50039L0.238281 8.38164Z"
                  fill="#213F98"
                />
              </g>
              <defs>
                <clipPath id="clip0_1058_1953">
                  <rect width="14" height="15" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className={"text-caption2 font-[600] text-primary-dark"}>
              <span className={"text-label2"}>
                상담사 고객 응대 및 관리 기능{" "}
              </span>
              <ul className={"pl-[0px]"}>
                <li className={"list-disc font-[500] text-gray-500"}>
                  고객이 문의 남길 시 상담사에게 알림 전달
                </li>
                <li className={"list-disc font-[500] text-gray-500"}>
                  상담사 답변을 고객 전달
                </li>

                <li className={"list-disc font-[500] text-gray-500"}>
                  상담 내역 확인 및 관리를 통한 효율적인 고객 관리
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingCardPro;
